import moment from 'moment-timezone';

const DEFAULT_TIMEZONE = 'America/Los_Angeles';

/**
 * Formats a date for display in the UI
 * Format: MM/DD/YYYY h:mma z (e.g., 01/15/2023 3:45pm PDT)
 *
 * @param {string|Date} date - The date to format
 * @param {string} timezone - The timezone to use (defaults to America/Los_Angeles)
 * @returns {string} The formatted date string
 */
export function formatDateForDisplay(date, timezone = DEFAULT_TIMEZONE) {
	if (!date) return '';
	return moment(date)
		.tz(timezone)
		.format('MM/DD/YYYY h:mma z');
}

/**
 * Formats a date for use in filenames
 * Format: MM-DD-YYYY_h:mm (e.g., 01-15-2023_3:45)
 *
 * @param {string|Date} date - The date to format
 * @param {string} timezone - The timezone to use (defaults to America/Los_Angeles)
 * @returns {string} The formatted date string
 */
export function formatDateForFilename(date, timezone = DEFAULT_TIMEZONE) {
	if (!date) return 'no-date';
	return moment(date)
		.tz(timezone)
		.format('MM-DD-YYYY_h:mm');
}

/**
 * Utility library for date formatting functions
 */
export default {
	formatDateForDisplay,
	formatDateForFilename,
};



// WEBPACK FOOTER //
// ./src/assets/js/lib/date-format-lib.js